import React from 'react';
import {Link as ReactLink, useParams} from 'react-router-dom';
import {useGetOppskrift} from '../hooks/useGetOppskrifter';
import {Heading, Stack, Text, Link, Flex, Grid} from '@chakra-ui/react';
import {ArrowBackIcon} from '@chakra-ui/icons';

const Oppskrift: React.FC = () => {
  const {oppskriftId} = useParams();
  const {oppskrift, isLoading} = useGetOppskrift(oppskriftId);

  if (isLoading) return <Text>Henter oppskriften …</Text>;
  if (!oppskrift) return <Text>Det er ingen oppskrift med den iden</Text>;

  return (
    <Stack spacing={2}>
      <Link as={ReactLink} to="/">
        <Flex alignItems={'center'}>
          <ArrowBackIcon ml={'-2rem'}/>
          <Text ml={2}size={'lg'}>Tilbake til alle oppskriftene</Text>
        </Flex>
      </Link>
      <Heading as={'h1'}>{oppskrift.title}</Heading>
      <Heading as={'h2'} size='lg'>
          Antall:
        {oppskrift.amount}
      </Heading>
      <Heading as={'h2'} size='lg'>
        {oppskrift.cookingTime}
      </Heading>
      <Grid pt={ 4 } gridTemplateColumns={{base: '1fr', md: '1fr 3fr'}} gap={6}>
        <ul>
          {oppskrift.ingredients.map((ingridient, index) => (
            <li key={index}>
              <Text fontSize={'xl'}>
                {ingridient}
              </Text>
            </li>
          ))}
        </ul>
        <ol>
          {oppskrift.approch.map((step) => (
            <li key={step}>
              <Text fontSize={'xl'}>
                {step}
              </Text>
            </li>))}
        </ol>
      </Grid>
    </Stack>
  );
};

export default Oppskrift;
